<template>
  <div class="btmWrap" :class="status.issueListViewBln ? 'active' : null ">
    <button class="isueList" @click.stop="toggleHandler">{{`${isProtocol?'이슈리스트':'실험타입'}`}}</button>
  </div>
</template>

<script>
import CommNew from "@processEditor/CommNew";
export default {
  props: {
    isProtocol : {type:Boolean, defualt:false},
  },
  mixins:[ CommNew ] , 
  methods : {
    toggleHandler () {
      console.log('Toggle handler : ', this.status ) ; 
      const { issueListViewBln } = this.status ; 
      this.viewToggleBln = issueListViewBln ; 
      this.updateStatus({ issueListViewBln : !issueListViewBln }) ; 
    } , 
  }
}
</script>

<style lang="scss" scoped>
  .btmWrap {
    --moveWidth : var( --protocol-lnb-width ); 
    --moveDuration: 0.45s; 
    display: flex; 
    flex-direction: column; 
    gap: var( --default-gap ); 
    margin-top: auto; 
    // margin-left: var( --default-gap ); 
    margin-bottom: var( --default-gap ); 

    position: absolute; 
    bottom: 0; 
    // left: var( --moveWidth ); 
    right: 0;
    z-index: 92;
    // transform: translateX( calc( var( --moveWidth ) * -1) ); 
    // transition: transform var( --moveDuration ); 
    transform: translate(100%, 0);

    &.active {
      // transform: translateX( 0px ); 
      .isueList {
        &::before {
          transform: rotate( 180deg ); 
        }
      }
    }

    button {
      display: flex; 
      align-items: center; 
      // width: 146px; 
      @include text-prt;
      @include text-prt-sb;

      &::before {
        content: ''; 
        display: inline-flex; 
        width: 24px; height: 24px; 
      }
      &.loadProtocol {
        &::before {
          background: url( '@/assets/icons/icon-protocol.svg' ) no-repeat center; 
        }
        height: 40px; 
        border: 1px solid $gray-d;
        font-size: 14px; 
        justify-content: center; 
        color: $gray-3;
      }
      &.isueList {
        &::before {
          background: url( '@/assets/icons/arrow.svg' ) no-repeat center; 
          margin-right: 8px; 
          transform: rotate( 0deg ); 
          transition: transform var( --moveDuration ); 
        }
        color: $gray-6; 
      }
    }
  }
</style>